import './App.css';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import DeactivateAccountScreen from './screens/DeactivateAccountScreen';
import HomeScreen from './screens/HomeScreen';
import PrivacyPolicyScreen from './screens/PrivacyPolicyScreen';
import SupportScreen from './screens/SupportScreen';
import TermsOfServiceScreen from './screens/TermsOfServiceScreen';

function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyScreen />} />
        <Route path="/terms-of-service" element={<TermsOfServiceScreen />} />
        <Route path="/delete-account" element={<DeactivateAccountScreen />} />
        <Route path="/deactivate-account" element={<Navigate to="/delete-account" replace />} />
        <Route path="/support" element={<SupportScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
